import React from 'react';
import DigitalDisplay from '../components/DigitalDisplay';
import IntroSequence from '../components/IntroSequence';
import HamburgerMenu from '../components/HamburgerMenu';
import WalletConnect from '../components/WalletConnect';

const Storyline = () => {
  return (
    <>
      <HamburgerMenu />
      <WalletConnect /> {/* Now outside DigitalDisplay */}
      <div className="page-container">
        <DigitalDisplay>
          <IntroSequence />
        </DigitalDisplay>
      </div>
    </>
  );
};

export default Storyline;
